import { CheckSquare } from 'lucide-react';
import { z } from 'zod';
import { CheckboxFieldInput, CheckboxFieldView } from '../renderers/fields/checkbox/checkbox-field';
import type { CheckboxFieldSchema, FieldDefinition } from '../types';

export const CheckboxDefinition: FieldDefinition<CheckboxFieldSchema, boolean | null | undefined> =
  {
    type: 'checkbox',
    toolboxLabel: 'Checkbox',
    category: 'Selection',
    description: 'A single toggle for True/False or Yes/No questions.',
    icon: CheckSquare,

    createDefault: (id) => ({
      id,
      type: 'checkbox',
      name: `checkbox_${id}`,
      label: 'New Checkbox',
      required: false,
    }),

    configSchema: [
      { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
      { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
      {
        id: 'required',
        type: 'checkbox',
        name: 'required',
        label: 'Must be checked?',
        required: false,
      },
    ],

    buildValidation: (field) => {
      const schema = z.boolean();
      if (field.required) {
        return schema.refine((val) => val === true, {
          message: `${field.label} must be checked`,
        });
      }
      return schema.optional();
    },

    editComponent: CheckboxFieldInput,
    viewComponent: CheckboxFieldView,
  };
